import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTranslation} from "react-i18next"
import {useForm} from "react-hook-form"
import axios from "axios"
import {API_LEXICONS} from "../../constants/apiUrls"
import useLexicons from "../../swrCustomHooks/useLexicons"

export default function AddLexiconsModalForm({closeModal}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {mutateLexicons} = useLexicons()
    const {register, handleSubmit, formState: {errors}} = useForm()

    const addTeamLexicon = (data) => {
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        const bodyRequest = {name: data.lexiconName}
        axios.post(API_LEXICONS, bodyRequest, headersRequest)
        .then(() => {
            closeModal()
            mutateLexicons()
        })
        .catch((error) => {
            console.error("POST /lexicons: ", error)
        })
    }

    return (
        <>
        <form className="lexicons-modal-form" onSubmit={handleSubmit(addTeamLexicon)}>
            <div className="field">
                <input type="text" id="lexicon-name" name="lexicon-name" placeholder={t("Lexicon name")} {...register("lexiconName", {required: true})}/>
            </div>
            <div className="actions">
                <button className="cancel-btn" onClick={closeModal}>{t("Cancel")}</button>
                <button className="append-btn">{t("Add")}</button>
            </div>
        </form>
        </>
    )
}